var React = require('react');

function RadioNotChecked (props) {
    return React.createElement("svg",props,React.createElement("ellipse",{"cx":"10","cy":"10.25","fill":"none","fillRule":"evenodd","stroke":"#B9C3CE","strokeWidth":"2","rx":"10","ry":"10.25","transform":"translate(1 1)"}));
}

RadioNotChecked.defaultProps = {"width":"22","height":"23","viewBox":"0 0 22 23"};

module.exports = RadioNotChecked;

RadioNotChecked.default = RadioNotChecked;
